import Cookies from "js-cookie";

class SiteBanner {
    constructor(el) {
        this.global_banner = el;
        this.close_btn = el.querySelector("[data-banner-close-btn]");

        this.maybeShowBanner();

        if (this.close_btn) {
            this.close_btn.addEventListener("click", this.closeBanner.bind(this));
        }
    }

    closeBanner(e) {
        e.preventDefault();

        if (!Cookies.get("announcement-close")) {
            Cookies.set("announcement-close", true);

            // Reset the CSS variable
            document.documentElement.style.setProperty("--announcement-height", "0px");

            // Remove banner from DOM
            if (this.global_banner) {
                this.global_banner.remove();
            }
        }
    }

    maybeShowBanner() {
        if (!this.global_banner) return;

        if (!Cookies.get("announcement-close")) {
            this.global_banner.style.display = ""; // show if hidden
            const height = this.global_banner.offsetHeight;

            // Set the CSS variable for layout spacing
            document.documentElement.style.setProperty("--announcement-height", `${height}px`);
        } else {
            this.global_banner.remove();
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const siteBanner = document.querySelector("[data-site-banner]");

    if (siteBanner) {
        new SiteBanner(siteBanner);
    }
});

export default SiteBanner;
